module.exports = __webpack_public_path__ + "img/business-intern-using-computer-MRC5FSL.b34b7d3f.jpg";